import React from "react";
import { useTranslation } from "react-i18next";

const mockPolicies = [
  { id: 1, title: "Acceptable Use of Technology", category: "Technology", lastUpdated: "2025-09-01", status: "Active" },
  { id: 2, title: "Student Code of Conduct", category: "Student Affairs", lastUpdated: "2025-08-15", status: "Active" },
  { id: 3, title: "Emergency Drill Procedures", category: "Safety & Security", lastUpdated: "2025-09-20", status: "Active" },
  { id: 4, title: "Homework and Grading Policy", category: "Academics", lastUpdated: "2025-07-30", status: "Review Needed" },
];

const PolicyManagement = () => {
  const { t } = useTranslation();

  return (
    <div className="p-6 sm:p-8 lg:p-10 bg-gray-50 min-h-screen space-y-8">
      <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-sm space-y-6">
        {/* Header */}
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-bold text-gray-800">{t("policy.title")}</h2>
          <button className="bg-indigo-600 text-white font-semibold py-2 px-4 rounded-md hover:bg-indigo-700 transition">
            {t("policy.addNew")}
          </button>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("policy.policyTitle")}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("policy.category")}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("policy.lastUpdated")}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("policy.status")}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("policy.actions")}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {mockPolicies.map((policy) => (
                <tr key={policy.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {policy.title}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {policy.category}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {policy.lastUpdated}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <span
                      className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                        policy.status === "Active"
                          ? "bg-green-100 text-green-800"
                          : "bg-yellow-100 text-yellow-800"
                      }`}
                    >
                      {policy.status === "Active"
                        ? t("policy.active")
                        : t("policy.reviewNeeded")}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <a href="#" className="text-indigo-600 hover:text-indigo-900 mr-4">
                      {t("policy.viewEdit")}
                    </a>
                    <a href="#" className="text-gray-500 hover:text-gray-800">
                      {t("policy.archive")}
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PolicyManagement;
